import { Injectable } from '@angular/core';
import { CheckItem } from '@app/models/_index';
import { Factory } from './_factory';
import { FilterCatalogItemService } from '@app/services/_index';

/**
 * Create Role Check Item Factory used by application
 * Creates instances of Role Check Items
 */

@Injectable({
  providedIn: 'root',
})
export class RoleCheckItemFactory implements Factory<CheckItem> {
  roles: CheckItem[] = [];
  isBuilding = false;

  /**
   * Call and build Role Check Items array.
   * Do not add or remove items from this array. Used as a read-only reference.
   */
  constructor(private filterCatalogItems: FilterCatalogItemService) {}

  /**
   * Build Role Check Items array
   */
  async build(): Promise<void> {
    if (this.isBuilding) {
      return;
    }
    this.isBuilding = true;

    // Donot change the param value for getAllObjects function as it is the fieldName of the roles in Docebo
    try {
      const getRoleItems = await this.filterCatalogItems.getAllObjects('Beyond - role');
      if (getRoleItems && getRoleItems.length > 0) {
        getRoleItems.forEach((allRoles) => {
          if (allRoles) {
            this.roles.push(
              new CheckItem(
                allRoles?.value?.toLowerCase().trim(),
                `${allRoles.value}`,
                false,
                `${allRoles?.value} (${allRoles?.count})`,
                ''
              )
            );
          }
        });
      }
    } catch (error) {
      console.error('Error Building roles', error);
    } finally {
      this.isBuilding = false;
    }
  }

  /**
   * Get the collection and build the roles
   * @returns - the copy of the roles
   */
  getCollection(): CheckItem[] {
    if (this.roles && this.roles.length === 0 && !this.isBuilding) {
      this.build();
    }
    return this.roles;
  }
}
